import { type JSX } from 'react';
import ErrorTemplate from '../../../components/Error/ErrorTemplate';
import { MetaTagsTemplate } from '../../../components/MetaTags/MetaTagsTemplate';
import Spinner from '../../../components/Spinner/Spinner';
import { useQueryTemplate } from '../../../helpers/hooks/useQueryTemplate/useQueryTemplate';
import { FocusManager } from '../../../helpers/oneNavigation/FocusManager';
import type { FetchDetails } from '../../../services/types';
import { FetchRequestTypes } from '../../../services/types';
import type { IShowcaseState } from '../data/formater';
import Showcase from './Showcase';
import { ShowcaseContextProvider } from './ShowcaseContext';

export type ShowcaseContainerProps = {
  onClickParameters?: FetchDetails['onClickParameters'];
  focusManager?: FocusManager;
  url: string;
  isMainTemplate?: boolean;
};

function ShowcaseContainer({
  onClickParameters,
  focusManager,
  url,
  isMainTemplate,
}: ShowcaseContainerProps): JSX.Element | null {
  const [{ isLoading, error, data }] = useQueryTemplate<IShowcaseState>(url, {
    onClickParameters,
    template: FetchRequestTypes.ShowcaseContainer,
    isMainTemplate,
  });

  if (isLoading) {
    return <Spinner />;
  }

  if (error) {
    return <ErrorTemplate error={error} />;
  }

  if (!data) {
    return null;
  }
  const { strates } = data;

  return (
    <ShowcaseContextProvider>
      <MetaTagsTemplate data={data} enableAlternateLinksUpdate />
      <Showcase key={url} strates={strates} focusManager={focusManager} />
    </ShowcaseContextProvider>
  );
}

export default ShowcaseContainer;
